/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-05-10 20:43:13
 * @modify date 2022-05-10 20:43:13
 * @desc [通用递归函数]
 */
import lodash from 'lodash';
/**
 * 数组转换为树
 * @param dataSource
 * @param params
 * @returns
 */
export function toArrayTree(dataSource, params) {
    params = lodash.merge({
        parentValue: 0,
        dataKey: 'Id',
        parentKey: 'parentId',
        childrenKey: 'childrens',
        tree: [],
        parents: [],
        valueGetter: (item) => item,
    }, params);
    // 搜索 parentKey 匹配所以 值
    lodash
        .filter(dataSource, [params.parentKey, params.parentValue])
        .map((item) => {
        item = lodash.cloneDeep(item);
        // parent key 值
        const parentValue = lodash.get(item, params.dataKey);
        // children
        const tree = lodash.get(item, params.childrenKey, []);
        // parents
        const parents = lodash.concat(params.parents, lodash.filter(dataSource, [params.dataKey, params.parentValue]));
        const childrens = toArrayTree(dataSource, lodash.assign({
            parentValue,
            tree,
            parents,
        }, lodash.omit(params, ['parentValue', 'tree', 'parents'])));
        lodash.set(item, params.childrenKey, childrens);
        item = params.valueGetter(item);
        lodash.set(item, 'parents', lodash.map(parents, params.valueGetter));
        lodash.set(item, params.parentKey, params.parentValue);
        params.tree.push(item);
    });
    return params.tree;
}
export function getParents(dataSource, params) {
    params = lodash.merge({
        parentValue: 0,
        dataKey: 'Id',
        parentKey: 'parentId',
        parents: [],
        valueGetter: (item) => item,
    }, params);
    // 搜索 parentKey 匹配所以 值
    lodash
        .filter(dataSource, [params.dataKey, params.parentValue])
        .map((item) => {
        item = lodash.cloneDeep(item);
        const parentValue = lodash.get(item, params.parentKey);
        item = params.valueGetter(item);
        const parents = getParents(dataSource, lodash.assign({
            parentValue,
        }, lodash.omit(params, ['parentValue', 'parents'])));
        params.parents = lodash.concat(parents, [item]);
    });
    return params.parents;
}
/**
 * 数组转 tree 有 maping 关系数据
 * @param dataSource
 * @param params
 * @returns
 */
export function toArrayTreeMaping(dataSource, params) {
    dataSource = lodash.cloneDeep(dataSource);
    params = lodash.merge({
        parentValue: [],
        dataKey: 'Id',
        parentRowKey: 'parentIds',
        childrenRowKey: 'childrenIds',
        parentKey: 'parents',
        childrenKey: 'childrens',
        valueGetter: (item) => item,
    }, params);
    /**
     * 获取父节点
     * @param item
     * @returns
     */
    const getParents = (item) => {
        const parentKeys = lodash.get(item, params.parentRowKey);
        return lodash.filter(dataSource, (chil) => lodash.includes(parentKeys, lodash.get(chil, params.dataKey)));
    };
    /**
     * 获取子节点
     * @param item
     * @returns
     */
    const getChildrens = (item) => {
        const childrenKeys = lodash.get(item, params.childrenRowKey);
        // return lodash.filter(dataSource, (chil) =>
        //   lodash.includes(childrenKeys, lodash.get(chil, params.dataKey)),
        // );
        return lodash.compact(lodash.map(childrenKeys, (key) => lodash.find(dataSource, [params.dataKey, key])));
    };
    /**
     * 格式化后的数据
     */
    const data = lodash.map(dataSource, (item) => {
        // const parents = getParents(item);
        const childrens = getChildrens(item);
        item = params.valueGetter(lodash.assign(item, {
            // [params.parentKey]: parents,
            [params.childrenKey]: childrens,
        }));
        return item;
    });
    return lodash.filter(data, (item) => lodash.isEqual(lodash.get(item, params.parentRowKey), params.parentValue));
}
